import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sveto govno",
  "description": "",
  "published": "2007-05-10T00:00:00.000Z",
  "redirect_from": ["/blog/sveto-govno/swizec/214"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes bolj kratek blog, ker se mi, po pravici povedano, ne ljubi, ker me iz nekega razloga boli hrbet ... neumne uteÅ¾i ... No v glavnem, v majhnih urah današnjega jutra je bila v divjino spušÄena nova stran `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=show_comics/comic=7"
      }}>{`stripa`}</a>{`. MogoÄe malÄek pozno, za las ... samo tri mesece. Prav tako pa nove strani ne bo še vsaj do oktobra.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      